import { Link } from 'react-router-dom';

import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';

import { SidebarMenu } from '../sidebar';

const centroLogo = process.env.PUBLIC_URL + '/Logo-Centro.png';

const Sidebar = (props: {
  className?: string;
  isDesktop: boolean;
  minimized: boolean;
  locked: boolean;
  onHover: (lockOption: boolean) => void;
  onMenuIconClick: () => void;
}): JSX.Element => {
  const { className, isDesktop, minimized, locked, onHover, onMenuIconClick } = props;

  return (
    <nav
      onMouseEnter={(): void => onHover(true)}
      onMouseLeave={(): void => onHover(false)}
      className={classNames(
        'flex flex-col bg-[var(--sidebar-bg-color)] text-[var(--sidebar-link-text-color)] whitespace-nowrap',
        className
      )}
    >
      {isDesktop && (
        <div className="h-[75px] flex flex-row items-center px-4 border-b border-[var(--sidebar-separator-color)]">
          <Link to="/" className="flex flex-col items-start">
            <img
              src={centroLogo}
              alt="Centro Logo"
              className={classNames(
                'transition-all duration-300',
                minimized ? 'h-[24px]' : 'h-[32px]'
              )}
            />
            {!minimized && (
              <span className="text-[9px] text-[var(--sidebar-menu-heading-color)] tracking-wide mt-0.5">
                Powered by Mezzo
              </span>
            )}
          </Link>
          <div className="flex-grow" />
          <Button
            className="absolute left-full translate-x-[-50%] w-[28px] h-[28px] flex justify-content-center p-0 bg-white text-gray-400 hover:text-gray-600 focus:shadow-none !border-[#E5E7EB] rounded-full shadow-sm"
            onClick={() => onMenuIconClick()}
          >
            <i className={classNames('pi pi-angle-double-right text-[0.7rem] transition-all duration-500 ease', locked && 'rotate-180')} />
          </Button>
        </div>
      )}
      <SidebarMenu className="flex-grow-1" minimized={minimized} />
    </nav>
  );
};

export default Sidebar;
